import clearancesImage from '../Images/Services/Yacht Clearances _ Customs & Immigration.jpg';
import shippingImage from '../Images/Services/Parts Shipping and Logistics _ Yacht & Container Shipping _ Race Yacht Support.jpg';
import shippingImageOne from '../Images/Services/Parts Shipping1.jpeg';
import shippingImageTwo from '../Images/Services/Parts Shipping2.jpeg';
import provisioningImage from '../Images/Services/Provisioning.jpg';
import oceanPantryLogo from '../Images/Services/OceanPantryLogo.gif';
import fuelImage from '../Images/Services/Fuel Bunkering _ Oils and Lubricants _ Potable Water Analysis.jpg';
import destinationImage from '../Images/Services/Destination Itineraries and Caribbean Wide Support.jpg';
import supportImage from '../Images/Services/web 3.jpg';
import ConciergeImage from '../Images/Services/Concierge Services _ Flight Bookings _ VIP Transport.png';


export const servicesData = [
  {
    slug: 'yacht-clearances-customs-immigration',
    name: 'Yacht Clearances / Customs & Immigration / Captain and Crew Changes',
    image: clearancesImage,
    intro: 'Arrive in Antigua and Barbuda with confidence. We help captains, owners and crew navigate entry and departure formalities efficiently.',
    description: 'Our local team coordinates the documents, authorities and timing involved in yacht clearance so you can focus on the vessel, guests and onward itinerary.',
    highlights: ['Arrival and departure Yacht Clearances ', 'Customs and immigration coordination', 'Crew and guest documentation support', 'Practical local requirements and updates'],
  },
  {
    slug: 'yacht-container-shipping-logistics',
    name: 'Parts Shipping and Logistics / Yacht & Container Shipping / Race Yacht Support',
    image: shippingImage,
    directoryCategory: 'Shipping & Logistics',
    intro: 'Complete transport and logistics solutions for yachts, containers, urgent parts, supplies and marine equipment.',
    description: 'From a single time-sensitive spare to a yacht or full container movement, we coordinate air and sea freight, international ports, local authorities and final delivery to the vessel.',
    highlights: ['Yacht transport and container shipping', 'Air and sea freight coordination', 'Customs documentation and port liaison', 'Urgent parts handling and last-mile delivery'],
    testimonial: {
      quote: 'Amazing job clearing out the shipments for the yachts yesterday! Everyone was shocked how quickly they were on the dock with the boats.',
      author: 'Ben Coppock',
      company: 'Tidal Marine',
    },
    gallery: [
      { src: shippingImageOne, alt: 'Race yacht receiving shoreside support at the dock' },
      { src: shippingImageTwo, alt: 'Race yacht crew underway in the Caribbean' },
    ],
  },
  {
    slug: 'provisioning',
    name: 'Provisioning',
    image: provisioningImage,
    intro: 'Fresh, reliable local provisioning, tailored to your guests, crew, and itinerary needs.',
    additionalIntro: 'International gourmet provisions, imported on demand through our trusted suppliers network.',
    supplierLink: {
      label: 'Suppliers',
      image: oceanPantryLogo,
      imageAlt: 'Ocean Pantry',
      href: 'http://localhost:5173/business/Ocean%20Pantry',
    },
    description: 'Share your preference lists and deadlines with our team. We source quality local and imported products, organize orders carefully and coordinate delivery to the yacht.',
    highlights: ['Guest and crew preference lists', 'Fresh produce and specialty items', 'Beverages and galley essentials', 'Coordinated marina or yacht delivery'],
    testimonial: {
      quote: 'Thank you and great working with you on this last boss trip. Fast turn around as ever and Chef appreciated the provisions delivered shoreside after hours….makes it all do-able! We’ll see you next time',
      attribution: 'Capt Klaus Jackson - MY Fortunate Sun',
    },
  },
  {
    slug: 'fuel-bunkering-oils-lubricants',
    name: 'Fuel Bunkering / Oils and Lubricants / Potable Water Analysis',
    image: fuelImage,
    intro: 'Dependable fuel and technical-fluid coordination for a smooth turnaround.',
    description: 'We arrange supply around your schedule and location, helping the captain and engineering team confirm quantities, specifications and safe delivery details.',
    highlights: ['Marine fuel bunkering coordination', 'Oils, lubricants and technical fluids', 'Quantity and specification confirmation', 'Delivery scheduling and local liaison'],
  },
  {
    slug: 'concierge-flight-bookings',
    name: 'Concierge Services / Flight Bookings / VIP Transport',
    image: ConciergeImage,
    intro: 'Personal shoreside support for guests and crew, from arrival through departure.',
    description: 'Our concierge team combines local knowledge with responsive planning to take care of transport, reservations, travel and the details that make an Antigua stay effortless.',
    highlights: ['Commercial and private flight assistance', 'Airport transfers and VIP transport', 'Restaurant and activity reservations', 'Guest and crew shoreside requests'],
    testimonial: {
      quote: 'Captains Connections services is exactly what we needed on our last few guest trips in the Caribbean. Windwards or Leewards, the insight needed for making informed decisions, not only on places that fit our needs, but on who best able to fulfill the numerous requests at each stop!',
      attribution: 'Klaus Jackson - Capt. Fortunate Sun',
    },
  },
   {
    slug: 'destination-itineraries-caribbean-support',
    name: 'Destination Itineraries and Caribbean Wide Support',
    image: destinationImage,
    intro: 'Thoughtful itineraries and trusted support throughout Antigua and the wider Caribbean.',
    description: 'We help shape routes around your guests’ interests, seasonal conditions and operational needs, then connect the yacht with dependable support across the region.',
    highlights: ['Bespoke destination planning', 'Anchorage and activity suggestions', 'Regional service coordination', 'On-the-ground Caribbean knowledge'],
    testimonial: {
      quote: `I can happily say that my experience dealing with Captain’s Connections and Mark Acosta was seamless and quite pleasurable — never one hiccup.

We engaged Mark to be our agent in Antigua and to help us with some challenges. Our trip was from St. Thomas to Grenada for hurricane season that summer. His help began in St. Martin and didn’t really end in Grenada.

Everyone at every stop along the way knows and respects Mark — he is the guy. I never heard one negative comment about him.

He checked in with us at every stop, both going down and returning to St. Thomas. His service never ends. It’s not about the money with Mark — he really cares.`,
      attribution: 'Capt. Dan Knoop SY Pelican',
    },
  },
  {
    slug: 'bridge-deck-interior-support',
    name: 'Bridge / Deck & Interior Support',
    image: supportImage,
    intro: 'Responsive shoreside support for bridge, deck and interior departments throughout your stay.',
    description: 'We connect your crew with trusted local products, specialists and practical assistance to keep day-to-day operations running smoothly.',
    highlights: ['Chandlery and galley supplies', 'Charts and electronics support', 'Interior services and floral arrangements', 'Skilled dayworker coordination'],
  },
];

const serviceDisplayOrder = [
  'yacht-clearances-customs-immigration',
  'yacht-container-shipping-logistics',
  'provisioning',
  'fuel-bunkering-oils-lubricants',
  'bridge-deck-interior-support',
  'concierge-flight-bookings',
  'destination-itineraries-caribbean-support',
];

export const getServicesInDisplayOrder = () => serviceDisplayOrder
  .map((slug) => servicesData.find((service) => service.slug === slug))
  .filter(Boolean);

const serviceSlugAliases = {
  'shipping-logistics': 'yacht-container-shipping-logistics',
  'yacht-container-shipping': 'yacht-container-shipping-logistics',
};

export const getServiceBySlug = (slug) => {
  const resolvedSlug = serviceSlugAliases[slug] || slug;
  return servicesData.find((service) => service.slug === resolvedSlug);
};
